<template>
  <section v-if="isActive" :aria-hidden="!isActive" class="tabs-component-panel" :id="computedId" role="tabpanel">
    <slot />
  </section>
</template>

<script>
/**
 * This component is for individual Tabs
 */

export default {
  name: "Tab",
  props: {
    id: { default: null },
    name: { required: true },
    suffix: { default: "" },
    isDisabled: { default: false },
    isVisible: { default: true },
    counter: { default: 0 },
    total: { default: 0 },
    icon: { default: "" },
    userListType: {
      type: String,
      default: null
    }
  },

  data: () => ({
    isActive: false
  }),
  watch: {
    isActive() {
      if (this.isActive && this.userListType) {
        this.$root.$emit("setUserListType", this.userListType);
      }
    }
  },
  computed: {
    header() {
      return this.icon + this.name + this.suffix;
    },

    computedId() {
      return this.id ? this.id : this.name.toLowerCase().replace(/ /g, "-");
    },

    hash() {
      if (this.isDisabled) {
        return "#";
      }

      return "#" + this.computedId;
    }
  }
};
</script>
